import { Row, Card, CardBody, Col } from "reactstrap";
// import Refercards from "../ReferCard/Refercards";
import { dynamicImage } from "../../../Service";
import { H6, Image } from "../../../AbstractElements";
// import CardHeaderCommon from "../../../CommonElements/CommonCardHeader/CardHeaderCommon";
// import { Monthly, totalBal, Weekly, Yearly } from "../../../utils/Constant";

// interface AccountOverviewProps {
//   FinalPayout: number;
//   FinalBalance: number;
// }
const AccountOverview = (props: any) => {
  // console.log(props.actOverviewData.FinalBalance,'balance');
  // console.log(props.actOverviewData.FinalPayout,'payout');

  const CardDataBal = [
    {
      id: 1,
         img: dynamicImage("Icons/1.png"),
      title: "Level Income",
      value: props.incomeData?.LevelIncome,
      // img: dynamicImage("Icons/payout.png"),
      // title: "Total Income",
      // value: props.incomeData.TotalLevelIncome,
    },
    {
      id: 2,
      // img: dynamicImage("Icons/1.png"),
      // title: "Level Income",
      // value: props.incomeData?.LevelIncome,
      img: dynamicImage("Icons/payout.png"),
      title: "Total Income",
      value: props.incomeData.TotalLevelIncome,
    },
  ];
  return (
    <Col xl="3" md="3" sm="6" className="px-3 px-md-0 order-md-3 order-3">
      <Row>
        {CardDataBal.map((itm: any) => (
          <Col xl="12" md="12" sm="12">
            <Card className="project-card mb-3 boxshadow">
              <CardBody className="p-0">
                <div className="totalBal" key={itm?.id}>
                  <Image
                    src={itm.img}
                    className="copy-icon"
                    alt="Copy Icon"
                  ></Image>
                  <div className="referblock">
                    <span className="ValueData">₹{itm?.value}</span>
                    <H6 className="mt-0">{itm?.title}</H6>
                  </div>
                </div>
              </CardBody>
            </Card>
          </Col>
        ))}
      </Row>
    </Col>
  );
};

export default AccountOverview;
